import { IssueStateGroupFront } from './issue.state-group.front';

export class ProformaLineasProformaFront {
    lineId: number;
    issueId: number;
    vivienda: string;
    estado: string;
    grupoEstadoKey: string;
    claseEstado: string;
    descripcion: string;
    localizacion: string;
    conforme: number;
    manoObra: number;
    material: number;
    issueStateGroup: IssueStateGroupFront;
    requierePresupuestoAprobado: boolean;
}
